import * as React from 'react';

function SvgArrowUp(props) {
  return (
    <svg width={8} height={6} viewBox="0 0 8 6" fill="none" {...props}>
      <path
        d="M3.663.99a.462.462 0 01.674 0l3.256 3.383c.311.323.097.885-.337.885H.744c-.434 0-.648-.563-.337-.886L3.663.99z"
        fill={props.color}
      />
    </svg>
  );
}

export default SvgArrowUp;